import { createSelector } from 'reselect';
import { findIndex, flow, get, getOr, isEqual, reduce } from 'lodash/fp';

const getFlattenOptions = createSelector(
  get(['options']),
  get(['placeholder']),
  flow(get(['options', 0, 'options']), Boolean),
  (options, placeholder, isGroupedOptions) => {
    if (isGroupedOptions) {
      options = reduce(
        (acc, { label, value, options, ...rest }) => [
          ...acc,
          { ...rest, label, value, isGroup: true },
          ...options,
        ],
        [],
        options,
      );
    }

    if (placeholder) {
      options = [
        { value: undefined, label: placeholder, isPlaceholder: true },
        ...options,
      ];
    }

    return options;
  },
);

const getOptions = createSelector(
  get(['options']),
  get(['placeholder']),
  flow(get(['options', 0, 'options']), Boolean),
  (options, placeholder, isGroupedOptions) => {
    if (isGroupedOptions) {
      options = reduce(
        (acc, option) => [...acc, { ...option, isGroup: true }],
        [],
        options,
      );
    }

    if (placeholder) {
      options = [
        { value: undefined, label: placeholder, isPlaceholder: true },
        ...options,
      ];
    }

    return options;
  },
);

const getSelectedOptionIndex = createSelector(
  getFlattenOptions,
  get(['input', 'value']),
  (options, value) => {
    const index = findIndex((option) => isEqual(value, option.value), options);

    return index === -1 ? 0 : index;
  },
);

const getSelectedOption = createSelector(
  getFlattenOptions,
  getSelectedOptionIndex,
  (options, index) => getOr({}, [index], options),
);

const hasSelectedOptionValue = createSelector(
  getSelectedOption,
  ({ value }) => value !== undefined,
);

export default {
  flattenOptions: getFlattenOptions,
  hasSelectedOptionValue,
  options: getOptions,
  selectedOption: getSelectedOption,
  selectedOptionIndex: getSelectedOptionIndex,
};
